import {Component, Input, OnInit} from '@angular/core';
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {DataPreviewComponent} from "../../../core/data-preview/data-preview.component";
import {DataTableComponent} from "../../../core/data-table/data-table.component";
import {DeleteButtonComponent} from "../../../core/delete-button/delete-button.component";
import {LoaderContainerComponent} from "../../../core/loader-container/loader-container.component";
import {ManageButtonComponent} from "../../../core/manage-button/manage-button.component";
import {NgIf} from "@angular/common";
import {QuickPreviewPanelComponent} from "../../../core/quick-preview-panel/quick-preview-panel.component";
import {ThemePalette} from "@angular/material/core";
import {Observable} from "rxjs";
import {ApiService, RagSessionDef, RagTemplateDef} from "../../../services/api.service";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {MatButtonModule} from "@angular/material/button";
import {RouteContainerComponent} from "../../../core/route-container/route-container.component";
import {MatIconModule} from "@angular/material/icon";
import {UserIdTagComponent} from "../../users/user-id-tag/user-id-tag.component";
import {RequireClaimsDirective} from "../../../auth/components/require-claims.directive";

@Component({
  selector: 'session-preview',
  standalone: true,
  imports: [
    ActionsContainerComponent,
    BackButtonComponent,
    DataPreviewComponent,
    DataTableComponent,
    DeleteButtonComponent,
    LoaderContainerComponent,
    ManageButtonComponent,
    NgIf,
    QuickPreviewPanelComponent,
    MatButtonModule,
    MatIconModule,
    RouterLink,
    RouteContainerComponent,
    UserIdTagComponent,
    RequireClaimsDirective
  ],
  templateUrl: './session-preview.component.html'
})
export class SessionPreviewComponent implements OnInit {

  @Input() hideActions = false
  @Input() color: ThemePalette

  sessionId?: string
  loader?: Observable<RagSessionDef>
  session?: RagSessionDef

  constructor(
    readonly api: ApiService,
    readonly activatedRoute: ActivatedRoute,
    readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.sessionId = this.activatedRoute.snapshot.params['sessionId']
    this.loader = this.api.getSession(this.sessionId!)
  }
}

